import {
  paramsSerializer,
  createUrl,
  ApiQueryParams,
  commonErrorHandling
} from 'store/utils/';
import { availabilityUtilisationDomain } from 'models';
import http from 'api/http';
import {
  AvailabilityResponse,
  AvailabilityUtilisation
} from 'models/Availability';
import { useDispatch } from 'react-redux';
import { setSnackbar, SnackbarStatus } from './snackbar';

export const getAvailabilityUtilisation = async (
  queryParams: ApiQueryParams
): Promise<AvailabilityUtilisation[]> => {
  try {
    const { data } = await http.get<AvailabilityResponse>(
      createUrl(availabilityUtilisationDomain),
      {
        params: {
          startDate: queryParams.startDate,
          endDate: queryParams.endDate,
          engineerId: queryParams.engineerId
        },
        paramsSerializer
      }
    );

    if (data.utilisation.length === 0) {
      return [];
    }

    return data.utilisation;
  } catch (error) {
    commonErrorHandling(error, availabilityUtilisationDomain.type);

    const dispatch = useDispatch();
    const errorCode = error.response?.status || '';

    dispatch(
      setSnackbar({
        title: `Error ${errorCode}`,
        message: 'Unable to fetch availability utilisation data.',
        show: true,
        status: SnackbarStatus.Error
      })
    );
    return [];
  }
};
